import { render, staticRenderFns } from "./StorageLocationView.vue?vue&type=template&id=295f0e3a"
import script from "./StorageLocationView.vue?vue&type=script&lang=js"
export * from "./StorageLocationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports